import { render, staticRenderFns } from "./SmsTextFieldComponent.vue?vue&type=template&id=581bf8bc&scoped=true&"
import script from "./SmsTextFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SmsTextFieldComponent.vue?vue&type=script&lang=js&"
import style0 from "./SmsTextFieldComponent.vue?vue&type=style&index=0&id=581bf8bc&prod&scoped=true&lang=css&"
import style1 from "./SmsTextFieldComponent.vue?vue&type=style&index=1&id=581bf8bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581bf8bc",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsConversation%2FSmsFooterComponents%2FSmsTextFieldComponent.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports